var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"my-header",style:({backgroundColor:_vm.myBackgroundColor})},[_c('div',{staticClass:"head-wrap"},[(_vm.backFlag)?_c('div',{staticClass:"left",on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"iconfont iconfangxiangzuoN"})]):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.headTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }